import { clsx } from "clsx";
import { HTMLAttributes, memo } from "react";
import { Icons } from "./@types/icons";
import styles from "./icon.module.scss";

export type Sizes = 8 | 12 | 14 | 16 | 18 | 24 | 32 | 36 | 40;

type Props = {
  name: Icons;
  flag?: boolean;
  size?: Sizes;
  dimensions?: Sizes;
} & HTMLAttributes<HTMLSpanElement>;

const Icon = (props: Props) => {
  const {
    onClick,
    name,
    className,
    flag = false,
    title,
    size,
    dimensions,
    ...spanProps
  } = props;
  return (
    <span
      onClick={onClick}
      className={clsx(
        flag ? `flag flag-${name}` : `icon icon-${name}`,
        size && styles[`icon-size-${size}`],
        dimensions && styles[`icon-dimension-${dimensions}`],
        className
      )}
      title={title}
      {...spanProps}
    ></span>
  );
};

export default memo(Icon);
